import React, { useEffect, useState } from "react";
// import Pusher from "pusher-js";
import {
  Button,
  Card,
  Badge,
  Row,
  Col,
  Avatar,
  message,
  Modal,
  Result,
  Spin,
} from "antd";
import {
  ArrowLeftIcon,
  CouponCart,
  DeleteIcon,
  LocationIcon,
  MoreIcon,
} from "../asset/icons/icons";
import Table from "react-bootstrap/Table";
// import carticonimage1 from "../asset/carticonimage1.jpg";
import EmptyCart from "../asset/EmptyCart.svg";
import opayimg from "../asset/opayimg.png";
// import nibbleslogo from "../asset/nibbleslogo.jpg";
// import { FormatNumber } from "../Utils/cartmgt";
import { useDispatch, useSelector } from "react-redux";
import {
  // checkPaymentIntent,
  createOpayPayment,
  // createPaymentIntent,
  deleteItemsInCart,
  // disableCart,
  // enableCart,
  getAllAvailableLocation,
  getItemsInCart,
  postVerifyTransaction,
  updateItemsInCart,
  // updatePaymentIntent,
} from "../redux/Actions";
import { getCartReducer } from "../redux/Reducer/cartReducer";
import { getPaymentReducer } from "../redux/Reducer/paymentReducer";
// import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import ChangeOrderLocationModal from "./changeOrderLocation";
import VerifyAccountModal from "./VerifyAccountModal";
// import PaystackPaymentButton from "./payStackPayment";
import PayStackButtonMethod from "./paystackButtonMethod";
import SearchableNumberSelect from "./UI/InputFields/SearchableNumberSelect";
// import Pusher from "pusher-js";
// import axios from "axios";
// import getOpayPaymentURL from "../Utils/getOpayPaymentURL";
// import getOpayKey from "../Utils/getOpayKeys";
// import axios from "axios";

const NewCart = ({
  initialCartItems,
  authuserdetails,
  handleVerifyStatus,
  userProfileDetails,
  setSelectedKey,
  onClose,
  setOpen,
  setConfettiActive,
}) => {
  const [modal2Open, setModal2Open] = useState(false);
  // const [messages, setMessages] = useState([]);
  // const [locationDetails, setLocationDetails] = useState({
  //   location_id:
  //     userProfileDetails?.data?.business?.state === "Abuja"
  //       ? 2
  //       : userProfileDetails?.data?.business?.state === "Port-Harcourt"
  //       ? 3
  //       : 1,
  //   location_name: userProfileDetails?.data?.business?.state,
  // });
  const [locationDetails, setLocationDetails] = useState("");
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFlutterModalOpen, setIsFlutterModalOpen] = useState(false);
  const {
    // deleteCartItems,
    // updateCartItems,
    verifyTransaction,
    availableLocations,
    isloadingAvailableLocations,
    isloadingverifyTransaction,
    isloadingUpdatedCartItem,
    isloadingCartItems,
  } = useSelector(getCartReducer);

  const {
    paymentLoading,
    // createdPaymentIntent,
    // createdPayment,
    // getPaymentIntent,
    // updatedPaymentIntent,
    // isCartDisabled,
  } = useSelector(getPaymentReducer);
  const dispatch = useDispatch();
  const [cartItems, setCartItems] = useState(initialCartItems || []);
  const [latestUpdatedCartItem, setLatestUpdatedCartItem] = useState({
    id: "",
    qty: "",
  });
  const [subtotal, setSubtotal] = useState(0);
  // const [serviceFee, setServiceFee] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [isOrderButtonDisabled, setIsOrderButtonDisabled] = useState(true);

  // Enable Pusher logging if needed (dev only)
  // Pusher.logToConsole = true;
  // const pusherKey = process.env.REACT_APP_PUSHER_APP_KEY;
  // const cluster = process.env.REACT_APP_PUSHER_APP_CLUSTER;

  // useEffect(() => {
  //   const channel = new BroadcastChannel('payment_channel');

  //   // Listen for messages on the channel
  //   channel.onmessage = (event) => {
  //     const { action } = event.data;

  //     if (action === 'disableCart') {
  //       dispatch(disableCart()); // Dispatch the disableCart action
  //     } else if (action === 'enableCart') {
  //       dispatch(enableCart()); // Dispatch the enableCart action
  //     }
  //   };

  //   // Clean up when the component is unmounted
  //   return () => {
  //     channel.close();
  //   };
  // }, [dispatch]); // Only re-run when `dispatch` changes

  // useEffect(() => {
  //   debugger
  //   // Dispatch action to check payment intent state when the component mounts

  //   dispatch(checkPaymentIntent(authuserdetails?.id));

  //   // Subscribe to the dynamic Pusher channel for this user
  //   const pusher = new Pusher(pusherKey, { cluster: cluster });
  //   const channel = pusher.subscribe(`payment-intent-channel-${authuserdetails?.id}`);

  //   // Listen for cart-lock event
  //   channel.bind('cart-lock', function (data) {
  //     if (data.userId === authuserdetails?.id) {
  //       dispatch(disableCart());  // Dispatch action to disable cart UI
  //     }
  //   });

  //   // Listen for cart-unlock event
  //   channel.bind('cart-unlock', function (data) {
  //     if (data.userId === authuserdetails?.id) {
  //       dispatch(enableCart());  // Dispatch action to enable cart UI
  //     }
  //   });

  //   // Cleanup the Pusher channel when the component unmounts
  //   return () => {
  //     channel.unbind_all();
  //     channel.unsubscribe();
  //   };
  // }, [dispatch, authuserdetails?.id, cluster, pusherKey]);

  // useEffect(() => {
  //   console.log(getPaymentIntent, "getting Payement Intent")

  //   debugger
  //   if (createdPaymentIntent || paymentLoading) {
  //     dispatch(disableCart());
  //   }
  //   if(getPaymentIntent!==undefined && Object.keys(getPaymentIntent).length !== 0){
  //       if(getPaymentIntent?.status === true){
  //         dispatch(disableCart());
  //       }else{
  //         dispatch(enableCart())
  //       }
  //   }
  //   if(createdPayment){
  //       dispatch(enableCart());
  //       dispatch(updatePaymentIntent(authuserdetails?.id))
  //   }
  // }, [createdPaymentIntent, getPaymentIntent,paymentLoading, createdPayment, authuserdetails?.id, dispatch])

  // console.log(getPaymentIntent,"getting payment intent")

  const handleQuantityChange = (value, itemId) => {
    const updatedCartItems = cartItems?.map((item) =>
      item?.id === itemId ? { ...item, qty: parseInt(value) || 0 } : item
    );
    setLatestUpdatedCartItem({
      ...latestUpdatedCartItem,
      id: itemId,
      qty: parseInt(value) || 0,
    });
    dispatch(updateItemsInCart(itemId, { qty: parseInt(value) || 0 }));
    setCartItems(updatedCartItems);
    console.log(cartItems, "cartItems");
  };

  const handleDeleteItem = (itemId) => {
    const updatedCartItems = cartItems?.filter((item) => item?.id !== itemId);
    dispatch(deleteItemsInCart(itemId));
    setCartItems(updatedCartItems);
  };

  const calculateTotals = () => {
    const newSubtotal = (cartItems || []).reduce(
      (acc, item) => acc + item?.product?.amount * Number(item?.qty),
      0
    );
    // const newServiceFee = newSubtotal * 0.075;
    // const newTotalCost = newSubtotal + newServiceFee;
    const newTotalQuantity = cartItems.reduce(
      (acc, item) => acc + Number(item?.qty),
      0
    );

    setSubtotal(newSubtotal);
    // setServiceFee(newServiceFee);
    setTotalCost(newSubtotal);
    setTotalQuantity(newTotalQuantity);
    if (userProfileDetails?.data?.user_type_id !== 5) {
      if (newTotalQuantity < 50) {
        message.warning(
          "You cannot place an order with less than 50 quantity."
        );
        setIsOrderButtonDisabled(true);
        // console.log(newTotalQuantity, "newTotalQuantity")
      } else {
        setIsOrderButtonDisabled(false);
        // console.log(newTotalQuantity, "newTotalQuantity")
      }
    } else {
    }
  };

  // console.log(isOrderButtonDisabled, "isOrderButtonDisabled")

  const FormatNumber = (number) => {
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(number);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    //   setIsModalOpen(false);
    // debugger
    setSelectedKey("6");
    setIsModalOpen(false);
    setOpen(false);
    // dispatch(updatedPaymentIntent(authuserdetails?.id));
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showFlutterModal = () => {
    setIsFlutterModalOpen(true);
    // dispatch(createPaymentIntent('flutterwave'));
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        })
      );
    }
  };
  const handleFlutterOk = () => {
    setIsFlutterModalOpen(false);
  };
  const handleFlutterCancel = () => {
    setIsFlutterModalOpen(false);
  };

  const handleChangeLocation = () => {
    setModal2Open(true);
    dispatch(getAllAvailableLocation());
  };

  const handleLocationChange = (locationid, locationname) => {
    // debugger
    // console.log(locationid, "getavailloc");
    // console.log(locationname, "getavaillocname");
    setLocationDetails({
      ...locationDetails,
      location_id: locationid,
      location_name: locationname,
    });
    setModal2Open(false);
  };

  // const config = {
  //   public_key: process.env.REACT_APP_FLUTTERWAVE_PUBLIC_KEY,
  //   tx_ref: `NB${Date.now()}`,
  //   amount: totalCost,
  //   currency: "NGN",
  //   payment_options: "card,mobilemoney,ussd",
  //   customer: {
  //     email: authuserdetails.email,
  //     phone_number: authuserdetails.phone,
  //     name: authuserdetails.name,
  //   },
  //   customizations: {
  //     title: "Nibbles Bakery",
  //     description: "Payment for items in cart",
  //     logo: nibbleslogo,
  //   },
  // };

  //   const myHeaders = new Headers();
  // myHeaders.append("Authorization", "Bearer OPAYPUB16360242611890.028229908152910155");
  // myHeaders.append("MerchantID", "256621110429740");
  // myHeaders.append("Content-Type", "application/json");

  // const raw = JSON.stringify({
  //   "amount": {
  //     "currency": "NGN",
  //     "total": 42500000
  //   },
  //   "country": "NG",
  //   "product": {
  //     "description": "Soft and fluffy tea buns, freshly baked to perfection with a sweet and buttery flavour. Perfect for snacking or pairing with your favourite hot beverage.",
  //     "name": "Hollie Mante Jr."
  //   },
  //   "reference": "NB173320156668308",
  //   "returnUrl": "http://localhost:3000/dashboard",
  //   "callbackUrl": "https://your-call-back-url",
  //   "userInfo": {
  //     "userEmail": "angelita44@yahoo.com",
  //     "userId": 382,
  //     "userMobile": "574-861-1939",
  //     "userName": "Hollie Mante Jr."
  //   }
  // });

  // const requestOptions = {
  //   method: "POST",
  //   headers: myHeaders,
  //   body: raw,
  //   redirect: "follow"
  // };

  // const checkoutItems = cartItems?.map((item) => ({
  //   // productId: item?.product_id,
  //   description: item?.product?.description,
  //   name: item?.user?.name,
  //   // price: item?.product?.amount, // Assuming price is in the lowest currency unit (e.g., Kobo for Naira)
  //   // quantity: item?.qty,
  //   // imageUrl: item?.product?.images[0]?.url
  // }));

  // console.log('Checkout Items:', checkoutItems); // To verify the transformed array

  // const handleReturnURL = () => {
  //   if (window.location.hostname === 'localhost') {
  //     return "http://localhost:3000/dashboard";
  //   } else {
  //     return "https://app.nibblesbakery.ng/dashboard";
  //   }
  // }

  // const opayConfig = {
  //   // reference: `NB${Date.now()}`,
  //   // mchShortName: "Nibbles Bakery",
  //   // // productName: "Apple AirPods Pro",
  //   // // productDesc: "The best wireless earphone in history",
  //   // userPhone: authuserdetails.phone,
  //   // // userRequestIp: "123.123.123.123",
  //   // amount: `${totalCost + 0+0}`,
  //   // currency: "NGN",
  //   // payTypes: ["BalancePayment", "BonusPayment", "OWealth"],
  //   // payMethods: ["account", "qrcode", "bankCard", "bankAccount", "bankTransfer", "bankUSSD"],
  //   // callbackUrl: "http://localhost:3000/dashboard",
  //   // returnUrl: "http://localhost:3000/dashboard",
  //   // expireAt: "10"

  //   amount: {
  //     currency: "NGN",
  //     total: parseInt(totalCost * 100),
  //   },
  //   country: "NG",
  //   // payMethod: "BankCard",
  //   payMethod: "OpayWalletNg",
  //   product: checkoutItems,
  //   reference: `NB${Date.now()}`,
  //   returnUrl: handleReturnURL(),
  //   // callbackUrl: "https://your-call-back-url",
  //   userInfo: {
  //     userEmail: authuserdetails.email,
  //     userId: authuserdetails.id,
  //     userMobile: authuserdetails.phone,
  //     userName: authuserdetails.name,
  //   },
  //   // "amount": {
  //   //     "currency": "NGN",
  //   //     "total": 42500000
  //   // },
  //   // "country": "NG",
  //   // "product": {
  //   //     "description": "Soft and fluffy tea buns, freshly baked to perfection with a sweet and buttery flavour. Perfect for snacking or pairing with your favourite hot beverage.",
  //   //     "name": "Hollie Mante Jr."
  //   // },
  //   // "reference": "NB173320156668308",
  //   // "returnUrl": "http://localhost:3000/dashboard",
  //   // "callbackUrl": "https://your-call-back-url",
  //   // "userInfo": {
  //   //     "userEmail": "angelita44@yahoo.com",
  //   //     "userId": 382,
  //   //     "userMobile": "574-861-1939",
  //   //     "userName": "Hollie Mante Jr."
  //   // }
  // };

  // const handleFlutterPayment = useFlutterwave(config);

  // const handleVerifyTransaction = (value) => {
  //   dispatch(
  //     postVerifyTransaction({
  //       reference: value.tx_ref,
  //       transaction_id: value.transaction_id,
  //       location_id: locationDetails.location_id,
  //       payment_channel: "flutterwave",
  //       user_type_id: userProfileDetails?.data?.user?.user_type_id,
  //     })
  //   );
  //   // dispatch(clearCartItems());
  //   setIsLoadingPayment(false);
  //   // dispatch(getItemsInCart(authuserdetails.id));
  // };

  const newOpayConfig = {
    platform: "web",
    amount: totalCost,
    location_id:
      userProfileDetails?.data?.location?.id || locationDetails?.location_id,
    is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
    payment_channel: "opay",
  };
  const handlePlaceOrderDist = (value) => {
    // debugger
    dispatch(
      postVerifyTransaction({
        reference: `NB${Date.now()}`,
        transaction_id:
          Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000,
        location_id:
          locationDetails === ""
            ? userProfileDetails?.data?.location?.id
            : locationDetails?.location_id,
        is_direct: userProfileDetails?.data?.user_type_id === 5 ? true : false,
      })
    );
    // dispatch(clearCartItems());
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        })
      );
    }
    setIsLoadingPayment(true);
    // dispatch(getItemsInCart(authuserdetails.id));
  };

  const handleOpayPayment = (value) => {
    setIsLoadingPayment(paymentLoading);
    if (latestUpdatedCartItem.id !== "") {
      dispatch(
        updateItemsInCart(latestUpdatedCartItem?.id, {
          qty: parseInt(latestUpdatedCartItem?.qty) || 0,
        })
      );
    }
    dispatch(createOpayPayment(newOpayConfig));
    // dispatch(createPaymentIntent("opay"))
    // dispatch(disableCart())
    // dispatch(getItemsInCart(authuserdetails.id));
  };
  // const handleOpayPayment = (value) => {
  //   debugger;
  //   if (userProfileDetails?.data?.status === 1) {
  //     setIsLoadingPayment(true);
  //     try {
  //       const response = axios.post(
  //         `${getOpayPaymentURL()}`,
  //         opayConfig,
  //         {
  //           headers: {
  //             "Access-Control-Allow-Origin": '*',
  //             Authorization: 'Bearer '+process.env.REACT_APP_OPAY_PK,
  //             "Content-Type": "application/json",
  //             MerchantId: `${process.env.REACT_APP_OPAY_MERCHANTID}`,
  //             Accept: "application/json",
  //           },
  //         }
  //       );
  //       if (response.message === "SUCCESSFUL") {
  //         // debugger
  //         console.log(response);
  //         dispatch(
  //           postVerifyTransaction({
  //             reference: response?.data?.reference,
  //             transaction_id: response?.data?.orderNo,
  //             location_id: locationDetails,
  //             payment_channel: "opay",
  //             is_direct: false,
  //           })
  //         );
  //         setIsLoadingPayment(false);
  //       } else {
  //         console.log(response);
  //       }
  //     } catch (err) {
  //       console.log(err);
  //     }
  //     // setIsLoadingFlutter(false);

  // //     fetch("https://testapi.opaycheckout.com/api/v1/international/cashier/create", requestOptions)
  // // .then((response) => response.text())
  // // .then((result) => console.log(result))
  // // .catch((error) => console.error(error));
  //   } else {
  //     showModal();
  //   }
  //   setIsLoadingPayment(false);
  //   // dispatch(getItemsInCart(authuserdetails.id));
  // };

  // Update cartItems when initialCartItems changes
  useEffect(() => {
    setCartItems(initialCartItems ?? []);
  }, [initialCartItems]);

  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      calculateTotals();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems]);

  useEffect(() => {
    if (verifyTransaction?.status === true) {
      // debugger
      // cartItems.map(item =>
      //         item.id === updateid ? { ...item, qty: updateQuantity } : item
      //     )
      dispatch(getItemsInCart(authuserdetails.id));
      onClose();
      setConfettiActive(true);
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyTransaction]);
  //   console.log(initialCartItems, "initialCartItems")
  //   console.log(cartItems, "cartItems")
  // console.log(locationDetails.location_id, "locationid")
  // console.log(locationDetails, "locationid");
  console.log(latestUpdatedCartItem, "latestUpdatedCartItem");

  return (
    <Card>
      <div className="dashboardcardpriceandcartdiv">
        <p
          className="typography"
          style={{ fontSize: "18px", fontWeight: "500", color: "#1A202C" }}
        >
          My Cart
        </p>
        <Button
          type="text"
          style={{ margin: "-1.5em 0px 0px 0px", padding: "0px" }}
        >
          <MoreIcon />
        </Button>
      </div>

      <Spin spinning={isloadingCartItems} tip="Loading Cart">
        {cartItems?.code !== "ERR_BAD_REQUEST" ? (
          cartItems?.length !== 0 ? (
            <div className="">
              <Badge size="small" count={cartItems?.length} color="#BDC167">
                <p
                  className="typography"
                  style={{
                    color: "#252A4D",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                >
                  Orders
                </p>
              </Badge>
              {/* Rest of your JSX for displaying cart items */}
              <Row>
                <Col span={24}>
                  <Table responsive borderless size="sm">
                    <thead>
                      <tr>
                        {/* <th></th> */}
                        <th className="cart-table-header-style">Item</th>
                        <th className="cart-table-header-style">Qty</th>
                        <th className="cart-table-header-style">Price</th>
                        <th></th>
                      </tr>
                    </thead>
                    {/* <Divider /> */}
                    <tbody>
                      {cartItems?.length !== 0 ? (
                        cartItems?.map((item, i) => (
                          <tr key={item.id}>
                            <td>
                              <div className="d-flex align-items-center gap-1">
                                <div>
                                  <Avatar
                                    size="medium"
                                    icon={
                                      <img
                                        src={item?.product?.images[0]?.url}
                                        alt="carticonimage1"
                                        draggable={false}
                                      />
                                    }
                                  />
                                </div>
                                <div>
                                  <p className="typography carttextproductnametypography">
                                    {item?.product?.name}
                                  </p>
                                  <p className="typography carttextproductpricetypography">
                                    {FormatNumber(item?.product?.amount)}
                                  </p>
                                </div>
                              </div>
                            </td>
                            <td>
                              {/* <Input min={1} value={item?.qty} onChange={(e) => handleQuantityChange(e.target.value, item.id)} placeholder="Qty" /> */}
                              {/* <Input
                                min={1}
                                value={item?.qty}
                                type="number"
                                placeholder="Qty"
                                onChange={(e) =>
                                  handleQuantityChange(e.target.value, item?.id)
                                }
                                // disabled={isCartDisabled}
                                style={{ width: "65px" }}
                              /> */}


                              <SearchableNumberSelect
                                value={item?.qty}
                                onChange={(val) =>
                                  handleQuantityChange(val, item?.id)
                                }
                                allowClear
                              />
                            </td>
                            <td>
                              <div className="dashboardcardpriceandcartdiv">
                                <p className="typography carttextproductQpricetypography">
                                  {FormatNumber(
                                    item?.product?.amount * item?.qty
                                  )}
                                </p>
                              </div>
                            </td>
                            <td>
                              <div className="dashboardcardpriceandcartdiv">
                                <Button
                                  type="text"
                                  style={{
                                    margin: "0px",
                                    padding: "0px",
                                    height: "fit-content",
                                  }}
                                  onClick={() => handleDeleteItem(item?.id)}
                                // disabled={isCartDisabled}
                                >
                                  <DeleteIcon />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : cartItems?.code === "ERR_BAD_REQUEST" ? (
                        <tr>
                          <td colSpan="4">
                            <p>No item in cart</p>
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </Table>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <div>
                    <p
                      className="typography"
                      style={{ fontWeight: 500, marginTop: "10px" }}
                    >
                      Nearest Pickup to you
                    </p>
                  </div>

                  <div className="dashboardcardpriceandcartdiv">
                    {locationDetails === "" ? (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${userProfileDetails?.data?.location?.name} - ${userProfileDetails?.data?.location?.address}`}
                      </p>
                    ) : (
                      <p className="cartnearestlocation">
                        <LocationIcon />
                        {`${locationDetails?.location_name}`}
                      </p>
                    )}
                    <Button
                      size="small"
                      className="cartnearestlocationbutton"
                      onClick={handleChangeLocation}
                    >
                      Change
                    </Button>
                    <ChangeOrderLocationModal
                      modal2Open={modal2Open}
                      setModal2Open={setModal2Open}
                      availableLocations={availableLocations}
                      isloadingAvailableLocations={isloadingAvailableLocations}
                      handleLocationChange={handleLocationChange}
                      defaultsel={
                        locationDetails === ""
                          ? userProfileDetails?.data?.location?.id
                          : locationDetails?.location_id
                      }
                    />
                  </div>

                  <div>
                    <p className="typography cartpickingwhenready">
                      You will be picking up your order from this location once
                      it is ready.
                    </p>
                  </div>

                  {/* <div style={{ display: "flex" }}>
                                    <Button size='small' className='cartadddetailbutton'>
                                        Add Details
                                    </Button>
                                    <Button size='small' className='cartadddetailbutton'>
                                        Add Note
                                    </Button>
                                </div> */}
                  <div style={{ marginTop: "2em" }}>
                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1">Discount</p>
                      <p className="typography">₦0</p>
                    </div>

                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1">Sub total</p>
                      <p className="typography">{FormatNumber(subtotal)}</p>
                    </div>

                    {/* <div className="cartpricesummariesdiv">
                    <p className="cartpricesummariestypog1">Service Fee</p>
                    <p className="typography">{FormatNumber(serviceFee)}</p>
                  </div> */}

                    <div className="cartpricesummariesdiv">
                      <p className="cartpricesummariestypog1 cartprices-total-txt">
                        Total
                      </p>
                      <p className="typography  cartprices-total-txt">
                        {FormatNumber(totalCost)}
                      </p>
                    </div>
                    {userProfileDetails?.data?.user_type_id === 5 ? (
                      <div className="mt-2">
                        <Button
                          block
                          size={"large"}
                          className="placeordercartbutton typography"
                          onClick={handlePlaceOrderDist}
                          disabled={
                            isLoadingPayment || isloadingverifyTransaction
                          }
                        >
                          Place Order
                        </Button>
                      </div>
                    ) : userProfileDetails?.data?.status === 1 ? (
                      <div>
                        <div className="cartpricesummariesdiv">
                          <Button
                            block
                            size={"large"}
                            className="cartcouponbutton typography"
                          >
                            <div className="d-flex justify-content-between align-items-center w-100">
                              <div className="d-flex align-items-center gap-2">
                                <CouponCart
                                  style={{ backgroundColor: "#BDC167" }}
                                />
                                <div>
                                  <span style={{ marginLeft: "1em" }}>
                                    Have a coupon code?
                                  </span>
                                </div>
                              </div>
                              <div className="">
                                <ArrowLeftIcon />
                              </div>
                            </div>
                          </Button>
                        </div>

                        <div className="mt-2">
                          <Button
                            block
                            size={"large"}
                            className="placeordercartbutton typography"
                            onClick={handleOpayPayment}
                            disabled={
                              isOrderButtonDisabled ||
                              isLoadingPayment ||
                              isloadingUpdatedCartItem
                            }
                            icon={
                              <img
                                src={opayimg}
                                alt="Opay"
                                style={{ height: "2.7em" }}
                              />
                            }
                          >
                            Pay with Opay
                          </Button>
                        </div>

                        <div>
                          <PayStackButtonMethod
                            userProfileDetails={userProfileDetails}
                            setIsLoadingPayment={setIsLoadingPayment}
                            isLoadingPayment={isLoadingPayment}
                            isloadingUpdatedCartItem={isloadingUpdatedCartItem}
                            showModal={showModal}
                            // setPaystackModalOpen={setPaystackModalOpen}
                            authuserdetails={authuserdetails}
                            totalCost={totalCost}
                            isOrderButtonDisabled={isOrderButtonDisabled}
                            postVerifyTransaction={postVerifyTransaction}
                            dispatch={dispatch}
                            latestUpdatedCartItem={latestUpdatedCartItem}
                            locationDetails={
                              locationDetails === ""
                                ? userProfileDetails?.data?.location?.id
                                : locationDetails?.location_id
                            }
                          />
                        </div>
                        <div className="cartpricesummariesplaceorderdiv">
                          <Button
                            block
                            size={"large"}
                            className="placeordercartbutton typography"
                            // onClick={() => {
                            //   if (userProfileDetails?.data?.status === 1) {
                            //     setIsLoadingPayment(true);
                            //     handleFlutterPayment({
                            //       callback: (response) => {
                            //         // console.log(response);
                            //         handleVerifyTransaction(response);
                            //         closePaymentModal(); // this will close the modal programmatically
                            //         setIsLoadingPayment(false);
                            //       },
                            //       onClose: () => {
                            //         setIsLoadingPayment(false);
                            //       },
                            //     });
                            //     // setIsLoadingFlutter(false);
                            //   } else {
                            //     showModal();
                            //   }
                            // }}
                            onClick={showFlutterModal}
                            disabled={
                              isOrderButtonDisabled ||
                              isLoadingPayment ||
                              isloadingUpdatedCartItem
                            }
                            icon={
                              <img
                                src={
                                  "https://logosmarcas.net/wp-content/uploads/2022/06/Flutterwave-Simbolo.png"
                                }
                                alt="Paystack"
                                style={{ height: "1.7em" }}
                              />
                            }
                          >
                            Pay with FlutterWave
                          </Button>
                        </div>
                      </div>
                    ) : (
                      <Button
                        block
                        size={"large"}
                        onClick={showModal}
                        style={{ fontSize: "13px", fontWeight: 400 }}
                        className="placeordercartbutton typography"
                      >
                        Verify your account to proceed with payment
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <img
              src={EmptyCart}
              alt="no order history"
              style={{ width: "100%" }}
              draggable={false}
            />
          )
        ) : (
          <img
            src={EmptyCart}
            alt="no order history"
            style={{ width: "100%" }}
            draggable={false}
          />
        )}
        <VerifyAccountModal
          isModalOpen={isModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
        <Modal
          title=""
          open={isFlutterModalOpen}
          onOk={handleFlutterOk}
          onCancel={handleFlutterCancel}
          footer={[
            <Button type="primary" onClick={handleFlutterOk}>
              OK
            </Button>,
          ]}
        >
          <Result
            status="warning"
            title="Service Currently Not Available, Kindly use another payment option."
          // extra={
          //   <Button type="primary" key="console">
          //     Go Console
          //   </Button>
          // }
          />
        </Modal>
      </Spin>
    </Card>
  );
};
export default NewCart;
